// src/redux/reducers/kitchenDiningReducer.js

const initialState = {
  loading: false,
  dining: null,
  success: false,
  error: null,
};

const kitchenDiningReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CREATE_KITCHEN_DINING_REQUEST":
      return { ...state, loading: true, success: false, error: null };

    case "CREATE_KITCHEN_DINING_SUCCESS":
      return { ...state, loading: false, success: true, dining: action.payload, error: null };

    case "CREATE_KITCHEN_DINING_FAILURE":
      return { ...state, loading: false, success: false, error: action.payload };

    default:
      return state;
  }
};

export default kitchenDiningReducer;
